/* eslint-disable ssr-friendly/no-dom-globals-in-react-fc */
import * as React from 'react';
import { MeasurerWrapper } from '../styles';
import { StateType } from './ToolbarWrapper';

export type Measurement = {
  width: number;
  gap: number;
};

/**
 * This component will mount once, measure the width of the "more"
 * content when it wraps and when it doesn't, and then pass that
 * information to the parent component.
 */
export const MoreMeasurer = ({
  more,
  onMount,
}: {
  more: (props: StateType) => React.ReactNode;
  onMount: (measurement: Measurement) => void;
}) => {
  const mounted = React.useRef(false);
  const wrappingRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!wrappingRef.current || mounted.current) {
      return;
    }

    const width = Math.ceil(wrappingRef.current.getBoundingClientRect().width);
    const gap = parseFloat(getComputedStyle(wrappingRef.current).gap);
    if (width && gap) {
      onMount({ width, gap });
      mounted.current = true;
    }
  });

  if (mounted.current) {
    return null;
  }

  // Using large numbers to measure initial width for less edge cases
  return (
    <MeasurerWrapper aria-hidden="true" ref={wrappingRef}>
      {more({ wraps: true, from: 8, count: 88 })}
    </MeasurerWrapper>
  );
};
